import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the PorcentaPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'porcenta',
})
export class PorcentaPipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, digts: number = 0) { // ...args -> quando aceita infinitos argumentos?

        //return new Intl.NumberFormat('pt-BR', {style: 'percent'}).format(value);
        return this.util.porcenta(value, digts);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/porcenta/porcenta.ts